import React from 'react';
import { AppBar, Toolbar, IconButton, Button, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import SearchIcon from '@mui/icons-material/Search';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const Navbar = ({ toggleSidebar, openSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isTokenValid } = useAuth();

  const { FullName, user } = useAuth();
  const handleGoBack = () => {
    navigate(-1); // history back
  };
  const handleRefresh = () => {
    navigate(location.pathname, { replace: true });
  };
  return (
    <AppBar
      position="fixed"
      className='justify-content-center head-navbar'
      sx={{
        width: '100%',
        zIndex: 3,
        color: '#fff',
        minHeight: '45px',
        [theme => theme.breakpoints.up('sm')]: {
          minHeight: '45px',
        },
      }}
    >
      <Toolbar
        sx={{
          minHeight: '45px',
          '@media (min-width: 600px)': {
            minHeight: '40px',
          },
        }}
        className='d-flex justify-content-between align-items-center'
      >
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={toggleSidebar}
        >
          <MenuIcon sx={{ color: "#ed1c24" }} />
        </IconButton>


        <img src="Images/Logo.png" alt="img" className="header-logo-img" />
        <IconButton
          edge="end"
          color="inherit"
          aria-label="refresh"
          onClick={handleRefresh}
        >
          <RefreshIcon className='text-red' />
        </IconButton>
        {/* <ul className="navbar-nav header-right">
          <li className="nav-item dropdown">
            <div className="input-group search-area">
              <input className="form-control form-control-sm" type="search" placeholder="جستجو..." />
              <span className="input-group-text">
                <SearchIcon />
              </span>
            </div>
          </li>
        </ul> */}
        {/* <div style={{ marginRight: 'auto', display: 'flex', alignItems: 'center', gap: '8px' }}>
          {location.pathname !== '/' && (
            <Button
              color="inherit"
              onClick={handleGoBack}
              startIcon={<ArrowBackIcon />}
            >
              بازگشت
            </Button>
          )}
        </div> */}
        {/* {FullName && (
          <Typography
            variant="body1"
            sx={{
              color: "primary",
              display: 'inline-block',
              fontSize: '0.9rem',
            }}
          >
            {FullName || 'کاربر'}
          </Typography>
        )} */}
      </Toolbar>
    </AppBar>
  );
};
export default Navbar;